/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import { BoxProps, Box, Typography } from '@mui/material';
import TestIds from '../../../../testIds';
import { Button } from '../../../../components/Button';

export interface FilterDropdownProps {
  children?: React.ReactNode | React.ReactNode[];
  onClear?: () => void;
  onSubmit?: () => void;
  title?: string;
  containerSx?: BoxProps;
}
export const FilterDropdown: React.FC<FilterDropdownProps> = ({
  children,
  onClear,
  onSubmit,
  title,
  containerSx,
}) => {
  return (
    <Box display='grid' gap={'32px'} {...containerSx}>
      {/* Clear Filters Action */}
      <Box width='100%' display='inline-flex' justifyContent='space-between'>
        <Typography variant='h4'>{title}</Typography>
        <Button variant='underline' onClick={onClear}>
          Clear Filter
        </Button>
      </Box>

      {/* Middle Children */}
      {children}

      {/* Closing Action */}
      <Button
        autoFocus
        variant='contained'
        onClick={onSubmit}
        data-testid={TestIds.components.filters.viewResults}
      >
        View results
      </Button>
    </Box>
  );
};
